import { useEffect } from 'react';

import {
  hasSeenMarkInitialWalkthrough,
  recordMarkInitialWalkthroughSeen,
} from 'components/shared/side-menu/side-menu-popover-events';

import { useOpen } from 'hooks/use-open';

import { trackMarkWalkthroughStarted } from '../analytics/mark-walkthrough-analytics';

export interface UseInitialWalkthroughResult {
  isOpen: boolean;
  close: () => void;
}

export const useInitialWalkthrough = (
  oktaUserId: string | undefined
): UseInitialWalkthroughResult => {
  const { isOpen, handleOpen, handleClose } = useOpen();

  useEffect(() => {
    if (!oktaUserId) return;
    if (hasSeenMarkInitialWalkthrough(oktaUserId)) return;

    handleOpen();
    trackMarkWalkthroughStarted('firstVisit');
  }, [oktaUserId, handleOpen]);

  const close = (): void => {
    recordMarkInitialWalkthroughSeen(oktaUserId);
    handleClose();
  };

  return { isOpen, close };
};
